<template>
    <section class="p-2 px-2.5 md:p-4 rounded-[0_0_11px_11px] md:rounded-[11px] bg-white">
        <div class="flex flex-col md:flex-row justify-between items-center pb-4">
            <StoreSectionTitle :title="$t('general.news_and_offers')" />
        </div>
        <div class="grid :grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-y-4 md:gap-y-6 md:gap-7 lg:gap-x-10 3xl:gap-x-12">
            <StoreNewsItem class="w-full " v-for="item in list" :key="item.id" :item="item" />
        </div>
        <!-- load more -->
        <div class="mt-10 flex justify-center" v-if="!isLoading && !hasReachedFullPages">
            <MoreButton :isLoadingMore="isLoadingMore" :loadMoreData="loadMoreData" />
        </div>
    </section>
</template>

<script>
import MoreButton from "../general/MoreButton.vue";
import StoreNewsItem from "./StoreNewsItem.vue";
import StoreSectionTitle from "./StoreSectionTitle.vue";

export default {
    props: {
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        isLoadingMore: {
            type: Boolean,
            required: false,
            default: false
        },
        hasReachedFullPages:{
            type: Boolean,
            required: true,
            default: false
        },
        list: {
            type: Array,
            required: true,
            default: () => ([])
        },
        loadMoreData: {
            type: Function,
            required: true
        }
    },
    components: {
        StoreSectionTitle,
        StoreNewsItem,
        MoreButton
    }
}
</script>

<style>

</style>